export default __webpack_public_path__ + "f567f1eb849e4615181bc694aedda9a5.glb";